function Login() {
    return <div className="container d-flex justify-content-center h-100">
 
    <div className="col-md-12 text-center">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>
            Sorry, the page you are looking
            for does not exist.
        </p>
    </div>
    </div>


 



}

export default Login;
